import React from 'react';
import styled from 'styled-components';
import LinkButton from '../../../ui/linkButton/LinkButton';
export default styled(LinkButton)(({ theme }) => ({
  color: theme.colors.primaryLightBlue,
}));
